import axios from 'axios';

const API_URL = 'https://dev-api.thoorigai.net/api/v1/extras';

const handleApiError = (error) => {
  if (error.response?.data) {
    return error.response.data;
  }
  return { success: false, message: 'An error occurred' };
};

export const getAllExtras = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-all-extras-items`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getExtraById = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/get-extra-item/${id}`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createExtra = async (formData) => {
  try {
    const response = await axios({
      url: `${API_URL}/create-extra-item`,
      method: 'POST',
      data: formData,
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateExtra = async (id, formData) => {
  try {
    const response = await axios({
      url: `${API_URL}/update-extra-item/${id}`,
      method: 'PUT',
      data: formData,
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteExtra = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/delete-extra-item/${id}`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

const extrasService = {
  getAllExtras,
  getExtraById,
  createExtra,
  updateExtra,
  deleteExtra,
};

export default extrasService;
